<template>
  <q-pull-to-refresh @refresh="refresh">
    <q-card flat class="q-gutter-sm">
      <SelectMasterTarget @target-selected="targetSelected"
                          @show-comments="showComments"
                          :duration-state="durationState"
                          @show-goods-group-dashboard="showGoodsGroupDashboard"/>
      <q-card-section class="no-padding q-ml-md q-mr-md">
        <q-banner rounded class="bg-red text-white" inline-actions v-if="prevents && prevents>0">
          <template v-slot:avatar>
            <q-avatar icon="warning"/>
          </template>
          <span>به دلیل وجود تعداد <span class="text-bold">{{ prevents }}</span> فاکتور تعیین تکلیف نشده امکان صدور سند پورسانت میسر نخواهد بود</span>
        </q-banner>
      </q-card-section>
      <q-card-section class="text-center" v-if="$store.state.roles.some(v=>['user_sell'].includes(v))">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <q-card class="shadow-10 q-ma-md">
              <UserOrdersInfo v-if="orders && orders.length>0"
                              :item.sync="orders.filter(record=> record.AcceptModirSalePay>0 || record.ArchiveSalePay>0)[0]"
                              :series="[orders.filter(record=> record.AcceptModirSalePay>0 || record.ArchiveSalePay>0)[0].AcceptModirSalePay, orders.filter(record=> record.AcceptModirSalePay>0 || record.ArchiveSalePay>0)[0].ArchiveSalePay]"/>
            </q-card>
          </div>
          <div class="col-xs-12 col-md-4">
            <ExitProductInfo v-if="exitProducts && exitProducts.length>0"
                             :item.sync="exitProducts.filter(record=> record.AcceptModirTotalCount>0 || record.ArchiveTotalCount>0)[0]"
                             :series="[exitProducts.filter(record=> record.AcceptModirTotalCount>0 || record.ArchiveTotalCount>0)[0].AcceptModirTotalCount, exitProducts.filter(record=> record.AcceptModirTotalCount>0 || record.ArchiveTotalCount>0)[0].ArchiveTotalCount]"/>
          </div>
          <div class="col-xs-12 col-md-4">
            <UserFactorsInfo v-if="factors && factors.length>0"
                             :start-date="startDate"
                             :end-date="endDate"
                             :user-id="factors[0].Sale_UserID"
                             :item.sync="factors.filter(record=> record.SalePay >0 || record.RetrunSalePay>0)[0]"
                             :profit="factors.filter(record=> record.SalePay >0 || record.RetrunSalePay>0)[0].Profit"
                             :target-profit="factors.filter(record=> record.SalePay >0 || record.RetrunSalePay>0)[0].TargetProfit"
                             :series="[factors.filter(record=> record.SalePay >0 || record.RetrunSalePay>0)[0].SalePay, factors.filter(record=> record.SalePay >0 || record.RetrunSalePay>0)[0].RetrunSalePay]"
                             :progress-sale-price="undefined" :sale-price="undefined" :target-id="undefined"/>
          </div>
          <div class="row full-width">
            <div class="col-xs-12">
              <SaleTargetList report-type="last" :user-id="parseInt($store.state.userId)" :read-only="true"/>
            </div>
          </div>
        </div>
      </q-card-section>
      <q-card-section class="no-padding" v-if="$store.state.roles.some(v=>['admin','salemanager'].includes(v))">
        <q-expansion-item
            v-if="orders.filter(record=> record.AcceptModirSalePay>0 || record.ArchiveSalePay>0).length>0"
            icon="info"
            class="q-mt-md"
            label="سفارشات نهایی و یا آرشیو"
            header-class="bg-indigo-10 text-white"
            expand-icon-class="text-white"
            :default-opened="!$q.screen.lt.md">
          <div class="row">
            <div v-for="(item, index) in orders.filter(record=> record.AcceptModirSalePay>0 || record.ArchiveSalePay>0)"
                 :key="`order-${index}`"
                 class="col-xs-12 col-md-2">
              <UserOrdersInfo :item.sync="item" :series="[item.AcceptModirSalePay, item.ArchiveSalePay]"/>
            </div>
          </div>
        </q-expansion-item>
      </q-card-section>
      <q-card-section class="no-padding" v-if="$store.state.roles.some(v=>['admin','salemanager'].includes(v))">
        <q-expansion-item
            v-if="exitProducts.filter(record=> record.AcceptModirTotalCount>0 || record.ArchiveTotalCount>0).length>0"
            icon="info"
            label="حواله های صادر شده"
            header-class="bg-indigo-10 text-white"
            expand-icon-class="text-white"
            :default-opened="!$q.screen.lt.md">
          <div class="row">
            <div
                v-for="(item, index) in exitProducts.filter(record=> record.AcceptModirTotalCount>0 || record.ArchiveTotalCount>0)"
                :key="`exitProduct-${index}`"
                class="col-xs-12 col-md-2">
              <ExitProductInfo :item.sync="item" :series="[item.AcceptModirTotalCount, item.ArchiveTotalCount]"/>
            </div>
          </div>
        </q-expansion-item>
      </q-card-section>
      <q-card-section class="no-padding"
                      v-if="$store.state.roles.some(v=>['admin','salemanager','can_see_porcant'].includes(v))">
        <q-expansion-item
            icon="info"
            label="فاکتور و فاکتور برگشتی"
            header-class="bg-indigo-10 text-white"
            expand-icon-class="text-white"
            v-if="factors && factors.length>0"
            :default-opened="!$q.screen.lt.md">
          <div class="row">
            <div v-for="(item, index) in factors"
                 :key="`factors-${index}`"
                 class="col-xs-12 col-md-3">
              <UserFactorsInfo :item.sync="item" :profit="item.Profit" :target-profit="item.TargetProfit"
                               :series="[item.SalePay, item.RetrunSalePay]"
                               :start-date="startDate"
                               :target-id="selectedTargetId"
                               :end-date="endDate"
                               :sale-price="salePrice"
                               :prevent-porsant-document="prevents"
                               :progress-sale-price="lodash.sumBy(factors, item=> item.SalePay)"
                               :user-id="item.Sale_UserID"/>
            </div>
          </div>
        </q-expansion-item>
      </q-card-section>
    </q-card>

    <q-dialog maximized v-model="commentsListDialog">
      <UserComments :customer-info="null" :start-date="commentStartDate" :end-date="commentEndDate"/>
    </q-dialog>

    <q-dialog maximized v-model="goodsGroupDashboard">
      <GoodsGroupDashboard :start-date="startDate" :end-date="endDate"/>
    </q-dialog>
  </q-pull-to-refresh>
</template>

<script>
import {mapActions} from 'vuex'
import UserOrdersInfo from "@/components/dashboard/UserOrdersInfo";
import ExitProductInfo from "@/components/dashboard/ExitProductInfo";
import UserFactorsInfo from "@/components/dashboard/UserFactorsInfo";
import UserComments from "@/components/comments/UserComments";
import SelectMasterTarget from "@/components/Targets/SelectMasterTarget.vue";
import SaleTargetList from "@/components/SaleTargets/SaleTargetList.vue";
import GoodsGroupDashboard from "@/components/dashboard/GoodsGroupDashboard.vue";

export default {
  name: 'MyOrders',
  components: {
    GoodsGroupDashboard,
    SaleTargetList, SelectMasterTarget, UserComments, UserFactorsInfo, ExitProductInfo, UserOrdersInfo
  },
  props: {
    durationState: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      goodsGroupDashboard: false,
      commentsListDialog: false,
      startDate: '',
      endDate: '',
      commentStartDate: '',
      commentEndDate: '',
      orders: [],
      exitProducts: [],
      factors: [],
      prevents: undefined,
      selectedTargetId: undefined,
      salePrice: undefined
    }
  },
  methods: {
    ...mapActions({
      getDashboard: 'Orders/getMyDashboard',
    }),
    refresh(done) {
      setTimeout(() => {
        this.loadData()
        done()
      }, 1000)
    },
    loadData() {
      this.orders = []
      this.exitProducts = []
      this.factors = []
      if (this.startDate && this.startDate !== '' && this.endDate && this.endDate !== '') {
        this.getDashboard({
          startDate: this.startDate.replaceAll('/', '-'),
          endDate: this.endDate.replaceAll('/', '-')
        }).then((res) => {
          this.orders = JSON.parse(res.orders)
          this.exitProducts = JSON.parse(res.exitProduct)
          this.factors = JSON.parse(res.factors)
          if (res.prevents && JSON.parse(res.prevents) && JSON.parse(res.prevents).length > 0) {
            this.prevents = JSON.parse(res.prevents)[0].PreventCount
          }
        }).catch(() => {
          this.$q.notify({
            message: 'هدف سازمانی در بازه زمانی انتخابی یافت نشد',
            position: 'top',
            color: 'negative',
            icon: 'negative'
          })
        })
      }
    },
    targetSelected(args) {
      this.selectedTargetId = args.targetId
      this.startDate = args.startDate
      this.endDate = args.endDate
      this.salePrice = args.salePrice
      this.$emit('target-selected', args)
      this.loadData()
    },
    showComments(args) {
      this.commentStartDate = args.startDate
      this.commentEndDate = args.endDate
      this.commentsListDialog = true
    },
    showGoodsGroupDashboard(args) {
      this.startDate = args.startDate.replaceAll("/", "-")
      this.endDate = args.endDate.replaceAll("/", "-")
      this.goodsGroupDashboard = true
    }
  },
  created() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
